module.exports = __webpack_public_path__ + "img/img_100brand_home@3x.104f6950.png";